import OrderDetailList from './OrderDetailList';

// Edit route renders the same list component - the drawer opens based on the URL
const orderdetails = {
    list: OrderDetailList,
    edit: OrderDetailList,
};

export default orderdetails;
